export const STEPS = ['account', 'address', 'delivery', 'payment'];

/** Desktop-only DrawerModal max-width overrides per registration step. Steps omitted use DrawerModal defaults. */
export const STEP_MODAL_MAX_WIDTH_CLASS_NAMES = {
    // account: 'md:max-w-[600px] lg:max-w-[600px]',
    payment: 'lg:max-w-[800px]',
};
